export default __webpack_public_path__ + "static/media/b2.183132ae.jpg";